import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { notification } from "../services";

class Header extends Component {
  state = {
    user: JSON.parse(localStorage.getItem("user"))
  };

  logout() {
    localStorage.clear();
    notification.success("Logging out...");
    setTimeout(() => {
      window.location.href = "/";
    }, 2000);
  }

  render() {
    return (
      <div className="header">
        <div className="logo">
          <img
            width="200px"
            height="45px"
            src="/assets/img/logo.png"
            alt="PhotonCommerce"
          />
        </div>
        <div className="user" style={{ float: "right" }}>
          <a href="/upgrade">Upgrade</a>
          &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; Hi!&nbsp;&nbsp;
          {this.state.user.first_name}&nbsp;
          {this.state.user.last_name}
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={this.logout}
            className="btn-sm btn btn-danger float-right"
          >
            Logout
          </button>
        </div>
      </div>
    );
  }
}

export default withRouter(Header);
